import dayjs from 'dayjs';
import { ContractDate } from '../Generated/Mark-It-View-Api';
import { numberToShortMonth } from './MonthHelper';
import { off } from 'process';
export class ContractDateHelper {
  public static toLabel(contractDate: ContractDate) {
    return `${numberToShortMonth(contractDate.month!)} ${contractDate.year}`;
  }

  public static addMonths(contractDate: ContractDate, monthsToAdd: number): ContractDate {
    const newDate = dayjs(ContractDateHelper.toDate(contractDate)).add(monthsToAdd, 'month');
    return {
      year: newDate.year(),
      month: newDate.month() + 1,
    };
  }

  public static getStartContractDate(year: number, offset?: number): ContractDate {
    let startMonth = { year: year, month: 1 };

    if (offset) {
      return this.addMonths(startMonth, offset);
    }

    return startMonth;
  }

  public static getFiscalYear(contractDate: ContractDate, offset: number) {
    const adjustedDate = this.addMonths(contractDate, -offset);
    return adjustedDate.year!;
  }

  public static fromDate(date: Date) {
    const day = dayjs(date);
    return { year: day.year(), month: day.month() };
  }

  public static toDate(contractDate: ContractDate) {
    return new Date(contractDate.year!, contractDate.month! - 1, 1);
  }

  public static toMonthYearString(date: ContractDate): string {
    return dayjs(`${date.year}-${date.month}-01`).format('MMMM YYYY');
  }

  public static isEqualTo(a: ContractDate | null | undefined, b: ContractDate | null | undefined) {
    return a?.year == b?.year && a?.month == b?.month;
  }

  public static isGreaterThanOrEqualTo(a: ContractDate, b: ContractDate) {
    if (a === undefined || b === undefined) return undefined;

    // If years are not the same, compare years directly
    if (a.year !== b.year) {
      return a.year! >= b.year!;
    }

    // If years are the same, compare months
    if (a.month !== b.month) {
      return a.month! >= b.month!;
    }

    // If both year and month are the same, return true (since they are equal)
    return true;
  }

  public static isLessThanOrEqualTo(a: ContractDate, b: ContractDate) {
    if (a === undefined || b === undefined) return undefined;

    // If years are not the same, compare years directly
    if (a.year !== b.year) {
      return a.year! <= b.year!;
    }

    // If years are the same, compare months
    if (a.month !== b.month) {
      return a.month! <= b.month!;
    }

    // If both year and month are the same, return true (since they are equal)
    return true;
  }

  public static sortAscending<T>(a: ContractDate, b: ContractDate): number {
    return this.sortDescending(a, b) * -1;
  }

  public static sortDescending<T>(a: ContractDate, b: ContractDate): number {
    if (!a?.year || !b?.year || !a?.month || !b?.month) {
      return 0;
    }
    if (a.year === b.year) {
      return a.month - b.month
    }
    return a.year - b.year;
  }

  public static sortByField<T>(a: T, b: T, getDate: (item: T) => ContractDate): number {
    const aDate = getDate(a);
    const bDate = getDate(b);
    return this.sortDescending(aDate, bDate);
  }
}
